import LayoutPadrao from 'lg-vue-components/layoutPadrao'

export default [
   {
      path: '/',
      redirect: '/periodos',
      component: LayoutPadrao,
      children: [
         {
            path: '/periodos/:id',
            name: 'periodos-editar',
            component: () => import('../pages/EditarPeriodoApuracao.vue')
         }
      ]
   },
   {
      path: '/',
      redirect: 'periodos',
      component: LayoutPadrao,
      children: [
         {
            path: '/periodos',
            name: 'periodos',
            component: () => import('../pages/ListarPeriodoApuracao.vue')
         }
      ]
   }
]
